import { useState, useEffect, Fragment } from "react";
import { Table, DatePicker, Input, Space, Select } from "antd";
import moment from "moment";
import { Link, useParams } from "react-router-dom";
import { useRequest } from "ahooks";
import { SearchOutlined } from "@ant-design/icons";
import { useAuthContext } from "@/components/auth/AuthProvider";
import DepartmentTypeSelect from "@/components/common/DepartmentTypeSelect";
import DepartmentSelect from "@/components/common/DepartmentSelect";
import { message as messageService } from "@/services";
import MessagePushButton from "../MessageDetail/MessagePushButton";
import MessageReportButton from "../MessageDetail/MessageReportButton";
import MessageIgnoreButton from "../MessageDetail/MessageIgnoreButton";
import MessageBackButton from "../MessageDetail/MessageBackButton";

function StatusOtherMessageTable() {
  const [version, setVersion] = useState(Date.now());
  const [statusFilter, setStatusFilter] = useState();
  const [code, setCode] = useState();
  const [department, setDepartment] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [keyword, setKeyword] = useState();
  const [pageSize, setPageSize] = useState(50);
  const [page, setPage] = useState(1);
  const auth = useAuthContext();
  const { statusType } = useParams();

  const {
    data = { total: 0, results: [] },
    loading,
    run,
  } = useRequest(
    (params, token) => {
      return messageService.listMyReceiveMessage(params, token);
    },
    {
      manual: true,
      throttleWait: 600,
    }
  );

  useEffect(() => {
    if (auth) {
      run(
        {
          version,
          status: statusType,
          status_filter: statusFilter,
          start_date: startDate,
          end_date: endDate,
          search: keyword,
          page,
          page_size: pageSize,
          department_type: code,
          department,
        },
        auth.token
      );
    }
  }, [
    run,
    keyword,
    page,
    pageSize,
    auth,
    code,
    department,
    statusType,
    statusFilter,
    startDate,
    endDate,
    version,
  ]);
  const columns = [
    {
      title: "序号",
      key: "num",
      width: 50,
      render: (text, record, index) => `${index + 1}`,
    },
    {
      title: "类型",
      key: "messageType",
      width: 80,
      render: (record) => record.type?.name,
    },
    {
      title: "上报单位",
      key: "department",
      width: 100,
      ellipsis: true,
      render: (record) => record.sender?.name,
    },
    {
      title: "标题",
      dataIndex: "title",
      render: (text, record) => (
        <Link to={`/workshop/mrece/detail/${record.id}`} target="_blank">
          {text}
        </Link>
      ),
    },
    {
      title: "日期",
      width: 140,
      dataIndex: "published_at",
      render: (text, record) => moment(text).format("YYYY-MM-DD HH:mm"),
    },
    {
      title: "状态",
      width: 80,
      dataIndex: "status_name",
    },
    {
      title: "批示",
      width: 100,
      dataIndex: "bounce_comment",
    },
    {
      title: "操作",
      width: 260,
      key: "status_name",
      render: (record) => (
        <Space>
          <MessageIgnoreButton
            type="link"
            size="small"
            messageId={record.id}
            callback={setVersion}
          />
          <MessageReportButton
            token={auth.token}
            type="link"
            size="small"
            messageId={record.id}
            callback={setVersion}
          />
          <MessagePushButton
            token={auth.token}
            type="link"
            size="small"
            messageId={record.id}
            callback={setVersion}
          />
          <MessageBackButton
            type="link"
            size="small"
            token={auth.token}
            messageId={record.id}
            callback={setVersion}
          />
        </Space>
      ),
    },
  ];
  return (
    <Fragment>
      <div className="table-toolbar">
        <div className="left"></div>
        <div className="right">
          <Space>
            <div>
              状态：
              <Select
                style={{ width: 80 }}
                onChange={(value) => setStatusFilter(value)}
              >
                <Select.Option value="3">未采用</Select.Option>
                <Select.Option value="5">退件</Select.Option>
              </Select>
            </div>
            <div>
              单位类型：
              <DepartmentTypeSelect value={code} onChange={setCode} />
            </div>
            <div>
              单位：
              <DepartmentSelect
                value={department}
                onChange={setDepartment}
                code={code}
              />
            </div>
            <div>
              日期：
              <DatePicker.RangePicker
                allowClear
                disabledDate={(current) => current.isAfter(moment())}
                onChange={(value) => {
                  setStartDate(value[0].format("YYYY-MM-DD"));
                  setEndDate(value[1].format("YYYY-MM-DD"));
                }}
              />
            </div>
            <div>
              标题：
              <Input
                prefix={<SearchOutlined style={{ color: "#ccc" }} />}
                style={{ width: 220 }}
                placeholder="搜索内容"
                allowClear
                onChange={(e) => setKeyword(e.target.value)}
              />
            </div>
          </Space>
        </div>
      </div>
      <Table
        rowKey="id"
        size="middle"
        columns={columns}
        dataSource={data.results}
        loading={loading}
        pagination={{
          pageSize: pageSize,
          total: data.count,
        }}
        onChange={({ current, pageSize }) => {
          setPage(current);
          setPageSize(pageSize);
        }}
      />
    </Fragment>
  );
}

export default StatusOtherMessageTable;
